<template>
  <modal @save="submit" @back="goBack">
    <template #header>{{ $t('reviewSubmit.modal.title.editAdditionalBusinessInfo') }}</template>
    <form autocomplete="off">
      <input-inline>
        <established-date
          id="business-established-date"
          name="business-established-year"
          v-model="business.establishedDate"
          :maxlength="ESTABLISHED_DATE_MAX_LENGTH"
          :placeholder="$t('moreBusinessInfo.businessEstablished.yearPlaceholder')"
          v-validation="[['dynamic', '/business/establishedDate']]"
          :disabled="hasParenApplicationtId"
        >
          <template #label>{{ $t('moreBusinessInfo.businessEstablished.yearLabel') }}</template>
        </established-date>

        <input-select
          v-if="isShowEstablishedMonth"
          id="business-established-month"
          name="business-established-month"
          class="establishedMonth"
          v-model="business._extension.establishedMonth"
          :defaultValue="$t('select')"
          :options="monthOptions"
          v-validation:closed="[['dynamic', '/business/_extension/establishedMonth']]"
        >
          <template #label>{{ $t('moreBusinessInfo.businessEstablished.monthLabel') }}</template>
        </input-select>
      </input-inline>

      <input-inline>
        <input-money
          id="gross-monthly-revenue"
          name="gross-monthly-revenue"
          v-model="business._extension.averageMonthlyRevenue"
          :strict-mode="{ regex: /[^0-9]/g, skipDefault: true }"
          :maxlength="AVERAGE_MONTHLY_REVENUE_MAX_LENGTH"
          :placeholder="$t('moreBusinessInfo.averageMonthlyRevenue.placeholder')"
          v-validation="[['dynamic', '/business/_extension/averageMonthlyRevenue']]"
        >
          <template #label>
            {{ $t('moreBusinessInfo.averageMonthlyRevenue.label') }}
          </template>
          <template #prefix>{{ $t('moreBusinessInfo.averageMonthlyRevenue.prefix') }}</template>
        </input-money>

        <input-percent
          id="percent-ownership"
          name="percent-ownership"
          v-model="owner.percentOwnership"
          :placeholder="$t('moreBusinessInfo.ownershipPercentage.placeholder')"
          aria-labelledby="ownership-percentage-column-header"
          v-validation="[['dynamic', '/owners/*/percentOwnership']]"
        >
          <template #label>
            {{ $t('moreBusinessInfo.ownershipPercentage.label') }}
          </template>
          <template #suffix>
            {{ $t('moreBusinessInfo.ownershipPercentage.suffix') }}
          </template>
        </input-percent>
      </input-inline>
    </form>
  </modal>
</template>

<script>
import Modal from '@/components/Modal';
import modalMixin from '@/mixins/modal';
import InputInline from '@/components/InputInline';
import InputPercent from '@/components/InputPercent';
import EstablishedDate from '@/components/EstablishedDate';
import {
  ESTABLISHED_DATE_MAX_LENGTH,
  AVERAGE_MONTHLY_REVENUE_MAX_LENGTH,
} from '@/modules/validation-service/fields-length';
import months from '@/modules/months';
import mapConstsToOptions from '@/utils/map-consts-to-options';

const MIN_YEAR_BUSINESS_ESTABLISHED = 2;

export default {
  name: 'edit-more-business-info',
  components: {
    Modal,
    InputInline,
    InputPercent,
    EstablishedDate,
  },
  data() {
    return {
      ESTABLISHED_DATE_MAX_LENGTH,
      AVERAGE_MONTHLY_REVENUE_MAX_LENGTH,
    };
  },
  computed: {
    business: {
      get() {
        return this.application.business;
      },
      set(value) {
        this.application = { ...this.application, business: value };
      },
    },
    owner: {
      get() {
        return this.application.owners[0];
      },
      set(value) {
        this.application = {
          ...this.application,
          owners: [value, ...this.application.owners.slice(1)],
        };
      },
    },
    isShowEstablishedMonth() {
      const [year] = this.business.establishedDate ? this.business.establishedDate.split('-') : '';
      if (year && year.length === ESTABLISHED_DATE_MAX_LENGTH) {
        const yearNow = new Date().getFullYear();
        if (yearNow - year < 0) {
          return false;
        }
        return yearNow - year <= MIN_YEAR_BUSINESS_ESTABLISHED;
      }
      return false;
    },
    monthOptions() {
      return mapConstsToOptions(months, 'months');
    },
    hasParenApplicationtId() {
      return !!this.application._extension.parentApplicationId;
    },
  },
  mixins: [modalMixin],
};
</script>

<style lang="sass" scoped>
::v-deep
  .formControl .label
    line-height: 2

.establishedMonth
  ::v-deep
    .label
      line-height: 1
</style>
